"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var CARET_OFFSET = 6 + 1 + 1;
function BarTooltipContainer(_a) {
    var show = _a.show, children = _a.children, tooltipProps = _a.tooltipProps, chartRef = _a.chartRef;
    var _b = tooltipProps || {}, tooltipPosition = _b.tooltipPosition, y = _b.y, _c = _b.xAxisName, xAxisName = _c === void 0 ? "" : _c;
    var tooltipRef = (0, react_1.useRef)(null);
    var _d = __read((0, react_1.useState)({
        left: 0,
        top: 0,
        visibility: "hidden",
        position: "fixed",
    }), 2), style = _d[0], setStyle = _d[1];
    (0, react_1.useEffect)(function () {
        var tooltipElm = (tooltipRef || {}).current;
        var chartElm = (chartRef || {}).current;
        if (!tooltipElm || !chartElm || !tooltipPosition || !y)
            return;
        var _a = chartElm.getBoundingClientRect(), top = _a.top, left = _a.left;
        setStyle(__assign(__assign({}, style), { left: left + (tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.x) - tooltipElm.offsetWidth / 2, top: top + y - tooltipElm.offsetHeight - CARET_OFFSET, visibility: Boolean(show) ? "visible" : "hidden" }));
    }, [JSON.stringify(tooltipPosition), show]);
    return (react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: Boolean(show), timeout: kaleidoscope_2.AnimationDuration.Medium }, function (status) { return (react_1.default.createElement(kaleidoscope_1.TooltipElement, { id: xAxisName, className: "chart__bar__tooltip-container", size: kaleidoscope_1.TooltipSize.Small, position: kaleidoscope_1.TooltipPosition.Top, style: style, transitionStatus: status, forwardRef: tooltipRef }, children)); }));
}
exports.default = BarTooltipContainer;
